import Vue from 'vue'
import Router from 'vue-router'

import home from '../components/home/home.vue'


Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.VUE_APP_BASE_PATH,
    routes: [


        {
            path: '/',
            component: home
        }
    ]
})